﻿'use strict'

window.initialButtonText = "Connect"; // Declare a global variable to store the initial button text
window.clickType = "social-overlay-toggle";
module.exports = (function () {

    // private methods


    // public methods

    /**
    * @ngdoc method
    * @name socialOverlayExpand
    **/
    var socialOverlayExpand = function () {
        var $contactToggle = $("#contact-expand");
        var $socialOverlayToggle = $("#social-overlay-toggle");
        // Function to handle the click event
        var handleClick = function () {
            var contactSection = $('.contact-footer-section');
            contactSection.toggleClass('contact-open');
            var $translationToggle = $("#translate-expanded");
            var stickyBtnContainer = $(".sticky-buttons");
            let parent = document.getElementById("contact-expand");
            let currentIconClassName = parent.querySelector(".fad"); // Select by class
            
            // Toggle the button text based on the presence of 'contact-open' class
            if (contactSection.hasClass('contact-open')) {
                $contactToggle.html(`<i class="${currentIconClassName.className}"></i> Close`);
                $translationToggle.prop('disabled', true);
                $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
                window.clickType = "social-overlay-toggle";
            } else {
                stickyBtnContainer[0].style.backgroundColor = "#3b3f42";
                $contactToggle.html(`<i class="${currentIconClassName.className}"></i> Connect`);
                $translationToggle.prop('disabled', false);
            }
        };

        // Attach the click event to both the toggle button and the close button
        $socialOverlayToggle.on("click", handleClick);
    };

    // Return an object exposing the public items
    return {
        initialize: socialOverlayExpand
    };

}());